import { Box, Text } from '@chakra-ui/react';
import { ReactNode } from 'react';
import Tooltip from '~/components/Tooltip';
import { InfoCircleIcon } from '~/components/icons/components/InfoCircleIcon';

interface Props {
  children: React.ReactNode;
  label: string;
  tooltipInfo: ReactNode;
}

export const MetricCard: React.FC<Props> = ({
  label,
  tooltipInfo,
  children,
}) => (
  <Box
    backgroundColor="transparent"
    borderWidth="1px"
    borderColor="primary.200"
    paddingTop={6}
    paddingBottom={9}
    paddingX={8}
    borderRadius="xl"
  >
    <Box>
      <Text
        as="span"
        textTransform="uppercase"
        fontWeight="medium"
        letterSpacing="wide"
        fontSize="md"
      >
        {label}
      </Text>
      {tooltipInfo && (
        <Tooltip
          label={tooltipInfo}
          fontSize="md"
          fontWeight="medium"
          isTouchFriendly
          shouldWrapChildren
        >
          <InfoCircleIcon
            color="primary.500"
            boxSize={4}
            marginLeft={3}
            cursor="pointer"
          />
        </Tooltip>
      )}
    </Box>
    <Box>{children}</Box>
  </Box>
);
